import { create } from 'zustand';
import { createAnalyzerSlice } from './analyzerSlice';
import { createAudioLevelMonitorSlice } from './audioLevelMonitorSlice';
import { createCoreSlice } from './coreSlice';
import { createDeviceSlice } from './deviceSlice';
import { createErrorsSlice } from './errorsSlice';
import { createLoggingSlice } from './loggingSlice';
import { createMicSlice } from './micSlice';
import { createRecordingSlice } from './recordingSlice';
import { createSourceSlice } from './sourceSlice';
import { createTaskQueueSlice } from './taskQueueSlice';
import { type AudioGraphStore } from './types';

export const useAudioGraphStore = create<AudioGraphStore>((...args) => ({
  ...createAnalyzerSlice(...args),
  ...createCoreSlice(...args),
  ...createSourceSlice(...args),
  ...createDeviceSlice(...args),
  ...createErrorsSlice(...args),
  ...createTaskQueueSlice(...args),
  ...createRecordingSlice(...args),
  ...createLoggingSlice(...args),
  ...createMicSlice(...args),
  ...createAudioLevelMonitorSlice(...args),
}));

useAudioGraphStore.getState().init();
